import React, { useState } from "react";
import Signin from "./Services/signin";
import { Navbar } from "./../components/navbar";
import { Sidebar } from "./Services/sidebar";

const SigninPage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <Signin />
    </>
  );
};

export default SigninPage;
